import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-accommodation-application-status",
  templateUrl: "./accommodation-application-status.component.html",
  styleUrls: ["./accommodation-application-status.component.scss"],
})
export class AccommodationApplicationStatusComponent implements OnInit {
  constructor(private httpClient: HttpClient) {}

  payload: any = {};

  notification = {};
  downloader: any = null;

  loading = false;
  skeletonLoader = true;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    const baseUrl = `${environment.BASE_URL}/accomodation/studentAccommodationQueueEntries`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.payload = res.Data;
        } else {
          this.notification = errorHandler(res);
        }
        this.skeletonLoader = false;
      },
      error: (err: any) => {
        this.skeletonLoader = false;
        this.notification = errorHandler(err);
      },
    });
  }
}
